import { createFileRoute } from "@tanstack/react-router";
import AccountSettingsPage from "@/site/pages/account-settings";

// Old app's account-settings page lived at /account — keep the URL (PRD 08 §6.2).
export const Route = createFileRoute("/account")({
  component: AccountSettingsPage,
});
